<template>
  <div class="Header">
    <div class="container">
      <div class="row">
        <!-- leftside -->
        <div class="col-md-6 title-text">
          <a href="#/" class="logo-link">
            <div>
              <strong>IMEJ Tech.com</strong>
              <a href="#/" class="logo-link">
                  <img src="../assets/logo.svg" id="logo" alt="logo" />
                  <div></div>
                </a>
            </div>
          </a>
          <a href="#/" class="under-logo-link">
            <strong><div>Website Development &amp; Design</div></strong>
          </a>
          <div class="established">
            <i class="fas fa-globe"></i> <strong>Established 2019 </strong>
            <i class="fas fa-globe"></i>
          </div>
        </div>
      </div>
    </div>

    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-nav>
          <b-navbar-toggle target="navbar-wrapper" class="toggle-button">
            <button class="btn btn-primary">
              <i class="fas fa-bars"></i>
              Welcome
            </button>
          </b-navbar-toggle>

          <b-collapse is-nav id="navbar-wrapper">
            <b-nav-item href="#/">Home <a href="#/" class="logo-link">
                <img src="../assets/logo.svg" id="logo" alt="logo" />
                <div></div>
              </a></b-nav-item>
            <b-nav-item to="About">About <a href="#/" class="logo-link">
                <img src="../assets/logo.svg" id="logo" alt="logo" />
                <div></div>
              </a></b-nav-item>
            <b-nav-item to="Portfolio">Portfolio <a href="#/" class="logo-link">
                <img src="../assets/logo.svg" id="logo" alt="logo" />
                <div></div>
              </a></b-nav-item>
            <b-nav-item to="Contact">Contact <a href="#/" class="logo-link">
                <img src="../assets/logo.svg" id="logo" alt="logo" />
                <div></div>
              </a></b-nav-item>
            <b-nav-item to="Sample">Sample <a href="#/" class="logo-link">
                <img src="../assets/logo.svg" id="logo" alt="logo" />
                <div></div>
              </a></b-nav-item>
          </b-collapse>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>

// import { BPagination } from 'bootstrap-vue';      old code, not used in this component

export default {
  name: "Header",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  color: white;
  background-image: url("../assets/DSCN0452.jpeg");
}
.nav-link {
  font-size: 26px !important;
}
.under-logo-link {
  font-size: 23px;
  text-align: center;
}
.nav {
  padding-bottom: 0;
}
.logo-con {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
}
.established {
  text-align: center;
  font-size: 20px;
}
.Header {
  background-color: #0d0004;
  background-image: url("../assets/ai-pic5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 240s ease-in-out infinite;
}
.Header >>> .navbar-dark .navbar-nav .nav-link {
  font-size: 22px;
  color: white;
  padding-bottom: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.Header >>> .bg-dark {
  background-color: transparent !important;
}
.Header >>> .navbar-expand {
  padding-right: 100px;
  justify-content: flex-end;
}
.logo-wrapper {
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.logo-link:hover {
  text-decoration: none;
  color: #007bff;
}
.logo-link {
  color: white;
  line-height: 40px;
  font-size: 31px;
  text-align: center;
}
.logo-blk {
  color: white;
}
#logo {
  height: 20px;
  padding-left: 0px;
}
.title-text {
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 34px;
  padding-left: 40px;
}

.Header >>> .toggle-button {
  width: 200px;
  border: none;
}
.div.app {
  background-color: lightgray;
}
.white-box:nth-child(2) {
  margin-left: 200px;
}
@media screen and (max-width: 1025px) {
  .white-box:nth-child(2) {
    margin-left: 100px;
  }
}
@media screen and (max-width: 768px) {
  .title-text {
    display: none;
  }
}
@media screen and (max-width: 400px) {
  .white-box:nth-child(2) {
    margin-left: 20px;
  }
}
.router-link-active {
  background-color: rgba(255, 50, 50, 0.5);
  border-radius: 8px 8px 0px 0px;
}
.white-box {
  background: white;
  padding: 10px;
  border: 1px solid white;
}
.deunderline:hover {
  text-decoration: none;
}
.under-logo-link {
  color: white;
}
.under-logo-link:hover {
  color: #007bff;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
